export enum Env {
  production = 'production',
  staging = 'staging',
  preview = 'preview',
  local = 'local'
}

const getEnv = (): Env => {
  const env = import.meta.env.VITE_APP_ENV;
  switch (env) {
    case Env.production:
      return Env.production;
    case Env.preview:
      return Env.preview;
    case Env.local:
      return Env.local;
    default:
      return Env.staging;
  }
};

export const currentEnv = getEnv();

export const IsProduction = (): boolean => {
  return currentEnv === Env.production;
};

export const IsDevMode = (): boolean => {
  return (
    currentEnv === Env.local ||
    currentEnv === Env.preview ||
    currentEnv === Env.staging
  );
};